
    <div
      *ngIf="possibilities$ | async as possibilities"
      class="d-flex flex-column"
      [class.d-flex-gap-2x]="possibilities | filled"
    >
      <div
        fieldmagicGridRow
      >
        <div
          *ngIf="possibilities | filled"
          class="d-flex d-flex-gap justify-content-between w-100 align-items-center"
        >
          <div fieldmagicGridColumn="6">
            <fieldmagic-dropdown-input
              class="w-100"
              [(ngModel)]="possibility"
              [options]="possibilities$ | async"
              [grouped]="true"
              placeholder="Please select a defect to add..."
              (ngModelChange)="onPossibilityChange()"
              [standalone]="true"
            >
              <ng-template
                fieldmagicDropdownOptionGroupTmp
                let-item="item"
              >
                <div
                  class="w-100 p-2"
                  [style.background]="item | data_get: 'first.color'"
                >
                  <span
                    [style.color]="item | data_get: 'first.color' | bg_text_color"
                  >
                    {{ item.text | translate }}
                  </span>
                </div>
              </ng-template>
            </fieldmagic-dropdown-input>
          </div>

          <div
            fieldmagicGridColumn="6"
            class="d-flex justify-content-end"
          >
            <fieldmagic-primary-button
              label="Add Fault"
              [icon]="[
                {
                  icon: 'plus-circle',
                  klass: 'text-success'
                }
              ]"
              purpose="icon"
              (click)="onAddFault()"
            >
            </fieldmagic-primary-button>
          </div>
        </div>

        <div
          *ngIf="possibilities | blank"
          fieldmagicGridColumn="12"
          class="d-flex d-flex-gap justify-content-end"
        >
          <fieldmagic-primary-button
            label="Add Fault"
            [icon]="[
              {
                icon: 'plus-circle',
                klass: 'text-success'
              }
            ]"
            purpose="icon"
            (click)="onAddFault()"
          >
          </fieldmagic-primary-button>
        </div>
      </div>

      <div
        fieldmagicGridRow
      >
        <div
          fieldmagicGridColumn="12"
        >
          <table class="table table-bordered">
            <thead>
              <tr>
                <td width="12%">
                  <fieldmagic-text
                    content="Severity"
                    purpose="table-header"
                    [withRequiredMarker]="true"
                  >
                  </fieldmagic-text>
                </td>
                <td width="40%">
                  <fieldmagic-text
                    content="Defect"
                    purpose="table-header"
                    [withRequiredMarker]="true"
                  >
                  </fieldmagic-text>
                </td>
                <td width="40%">
                  <fieldmagic-text
                    content="Comments"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="5%">
                  <div class="d-flex d-flex-gap align-items-center justify-content-center">
                    <fieldmagic-text
                      content="Acknowledged?"
                      purpose="table-header"
                    >
                    </fieldmagic-text>

                    <fieldmagic-checkbox-input
                      [useNative]="true"
                      [(ngModel)]="acknowledgedAll"
                      tooltip="Click to mark/unmark all as acknowledged"
                      (ngModelChange)="onAcknowledgedAll($event)"
                    >
                    </fieldmagic-checkbox-input>
                  </div>
                </td>
                <td width="5%">
                  <div class="d-flex d-flex-gap align-items-center justify-content-center">
                    <fieldmagic-text
                      content="Resolved?"
                      purpose="table-header"
                    >
                    </fieldmagic-text>

                    <fieldmagic-checkbox-input
                      [useNative]="true"
                      [(ngModel)]="resolvedAll"
                      tooltip="Click to mark/unmark all as resolved"
                      (ngModelChange)="onResolvedAll($event)"
                    >
                    </fieldmagic-checkbox-input>
                  </div>
                </td>
                <td width="5%">
                  <fieldmagic-text
                    content="Photo"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="5%">
                </td>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngIf="fetching$ | async">
                <tr class="text-center">
                  <td colspan="7">
                    <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="! (fetching$ | async)">
                <ng-container *ngIf="faults$ | async as faults">
                  <tr
                    *ngIf="isEmpty"
                    class="text-center"
                  >
                    <td colspan="7">No defects recorded for this asset.</td>
                  </tr>

                  <ng-container *ngFor="let fault of faults; let fault_index = index;">
                    <ng-container *ngIf="! fault.deleted">
                      <tr>
                        <td
                          *ngIf="fault.asset_type_severity_id | filled"
                          [style.background]="fault.color"
                          [style.color]="fault.color | bg_text_color"
                        >
                          {{ fault.severity }}
                        </td>

                        <td
                          *ngIf="fault.asset_type_severity_id | blank"
                        >
                          <div class="d-flex d-flex-gap align-items-center">
                            <fieldmagic-color-picker-input
                              [displayOnly]="true"
                              [displayValue]="false"
                              [standalone]="true"
                              [(ngModel)]="fault.color"
                            >
                            </fieldmagic-color-picker-input>

                            <fieldmagic-dropdown-input
                              class="w-100"
                              [options]="severities$ | async"
                              [(ngModel)]="fault.dropdown_key"
                              bindValue="dropdown_key"
                              (ngModelChange)="onSeverityChange(fault_index, $event)"
                            >
                            </fieldmagic-dropdown-input>
                          </div>
                        </td>


                        <td *ngIf="fault.asset_type_severity_id | filled">
                          <span>{{ fault.fault }}</span>
                        </td>

                        <td *ngIf="fault.asset_type_severity_id | blank">
                          <fieldmagic-textarea-input
                            [standalone]="true"
                            [expandable]="true"
                            [(ngModel)]="fault.fault"
                            (ngModelChange)="emitChanged()"
                            placeholder="Please tell us about the fault."
                          >
                          </fieldmagic-textarea-input>
                        </td>

                        <td>
                          <fieldmagic-textarea-input
                            [standalone]="true"
                            [(ngModel)]="fault.comments"
                            placeholder="Comments"
                            [expandable]="true"
                            (ngModelChange)="emitChanged()"
                          >
                          </fieldmagic-textarea-input>
                        </td>
                        <td class="text-center">
                          <div class="d-flex justify-content-center align-items-center w-100 h-100">
                            <fieldmagic-checkbox-input
                              [useNative]="true"
                              [(ngModel)]="fault.acknowledged"
                              tooltip="Mark as acknowledged"
                              (ngModelChange)="emitChanged()"
                            >
                            </fieldmagic-checkbox-input>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex d-flex-gap justify-content-center align-items-center w-100 h-100">
                            <fieldmagic-checkbox-input
                              [useNative]="true"
                              [(ngModel)]="fault.resolved"
                              tooltip="Mark as resolved"
                              (ngModelChange)="emitChanged()"
                            >
                            </fieldmagic-checkbox-input>

                            <fieldmagic-icon
                              *ngIf="fault.resolved"
                              [icon]="[{
                                icon: 'info-circle',
                                klass: 'text-info'
                              }]"
                              tooltip="Click here to add resolution notes"
                              (click)="onViewResolutionNotes(fault_index)"
                            >
                            </fieldmagic-icon>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex d-flex-gap justify-content-center align-items-center w-100 h-100">
                            <ng-container
                              *ngIf="fault.image_path | filled"
                            >
                              <a
                                href="{{ fault.image_url }}"
                                target="_blank"
                                matTooltip="{{ 'View Photo' | translate }}"
                                class="btn btn-link"
                              >
                                <fieldmagic-icon
                                  icon="file-image"
                                >
                                </fieldmagic-icon>
                              </a>

                              <span>/</span>

                              <fieldmagic-primary-button
                                purpose="delete-icon"
                                tooltip="Remove Photo"
                                (click)="onImageRemove(fault_index)"
                              >
                              </fieldmagic-primary-button>
                            </ng-container>

                            <ng-container
                              *ngIf="fault.image_path | blank"
                            >
                              <span>--</span>
                            </ng-container>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center align-items-center w-100 h-100">
                            <fieldmagic-primary-button
                              purpose="delete-icon"
                              (click)="onFaultRemove(fault_index)"
                            >
                            </fieldmagic-primary-button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  